import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Advantages } from './components/Advantages';
import { Business } from './components/Business';
import { Technology } from './components/Technology';
import { Timeline } from './components/Timeline';
import { Partners } from './components/Partners';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { AIChatBot } from './components/AIChatBot';


export default function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Advantages />
        <Business />
        <Technology />
        <Timeline />
        <Partners />
        <Contact />
      </main>
      <Footer />
      <AIChatBot />
    </div>
  );
}